'use client';

import { createContext, useState } from 'react';

import { YmapClinicClient } from '@/shared/types/ymaps';
import { GoogleMediaAd } from '@/shared/ui/ads';

import ClinicsList from './ClinicsList';
import TextContainer from './TextContainer';

interface ClinicsContextType {
  categoryName: string;
  clinicsCount: number | undefined;
  ymapCompany: YmapClinicClient | null | undefined;
  isLoading: boolean;
  setCategoryName: (catName: string) => void;
  setClinicsCount: (count: number | undefined) => void;
  setYmapCompany: (ymapCompany: YmapClinicClient | null | undefined) => void;
  setLoading: (isLoading: boolean) => void;
}

const noOp = () => {};

export const ClinicsContext = createContext<ClinicsContextType>({
  categoryName: '',
  clinicsCount: undefined,
  ymapCompany: undefined,
  isLoading: false,
  setCategoryName: noOp,
  setClinicsCount: noOp,
  setYmapCompany: noOp,
  setLoading: noOp
});

export function Clinics() {
  const [categoryName, setCategoryName] = useState('Категория не выбрана');
  const [clinicsCount, setClinicsCount] = useState<number | undefined>(undefined);
  const [ymapCompany, setYmapCompany] = useState<YmapClinicClient | null | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);

  return (
    <ClinicsContext.Provider
      value={{
        categoryName,
        clinicsCount,
        ymapCompany,
        isLoading,
        setCategoryName,
        setClinicsCount,
        setYmapCompany,
        setLoading
      }}
    >
      <TextContainer />
      <GoogleMediaAd inactive />
      <ClinicsList />
    </ClinicsContext.Provider>
  );
}
